export default __webpack_public_path__ + "static/Tagline-b42f801e141b4f7e159d2b1314d2b571.webp";